module.exports = __webpack_public_path__ + "static/homepage_hero3-6297d87a7269750b327470d080746bf7.png";